<template>
    <div class="container-fluid max-container">
        <div class="row">
            <Header />
            <section v-if="showKitNotice" class="recent-ancetry-wrapper">
                <div class="container">
                    <div class="row">
                        <KitPendingNotice product="Neanderthal ancestry" />
                    </div>
                </div>
            </section>
            <page-loader v-else-if="loadingStatus == 'loading'" />
            <section v-else-if="loadingStatus == 'loaded'" class="recent-ancetry-wrapper">
                <div class="container">
                    <div class="row">
                        <ArchaicNavigation />
                        <router-view v-if="archaicResult.barcode" :archaic-result="archaicResult" />
                    </div>
                </div>
            </section>
            <ArchaicStatus v-else :status="loadingStatus" />
        </div>
    </div>
</template>

<script>
import { ref, computed } from "vue";
import Header from "@/components/header/Header.vue";
import ArchaicStatus from "@/view/archaic/ArchaicStatus.vue"
import ArchaicNavigation from "./ArchaicNavigation.vue";
import store from "@/store/index";
import { getArchaicResult } from "@/services/archaic";
import KitPendingNotice from "@/components/kit/KitPendingNotice.vue";
import { useAncestryKit } from "@/composables/useAncestryKit";

const actions = {
    completed: (loadingStatus, archaicResult) => {
        getArchaicResult(store.getters.profile.profile.barcode)
            .then((res) => {
                archaicResult.value = JSON.parse(res.results);
            })
            .then(() => (loadingStatus.value = "loaded"))
            .catch((e) => {
                console.error(e);
                loadingStatus.value = "loadingFailed";
            });
        loadingStatus.value = "loaded";
    },
    // A test being updated to a new version keeps its previous results meanwhile
    updating: (loadingStatus, archaicResult) => actions.completed(loadingStatus, archaicResult),
    error: (loadingStatus) => {
        loadingStatus.value = "testErrored";
    },
    failed: (loadingStatus) => {
        loadingStatus.value = "testFailed";
    },
    pending: (loadingStatus) => {
        loadingStatus.value = "resultPending";
    },
    noData: (loadingStatus) => {
        loadingStatus.value = "testNoData";
    },
    processing: (loadingStatus) => {
        loadingStatus.value = "resultPending";
    },
};

export default {
    name: "ArchaicSection",
    // Component logic
    components: {
        Header,
        ArchaicNavigation,
        ArchaicStatus,
        KitPendingNotice
    },
    setup() {
        // A kit on its way to results that includes Neanderthal: where it's up to
        const { pending: kitPending } = useAncestryKit();
        const showKitNotice = computed(() => kitPending.value && store.getters.kitTests?.archaic?.purchased === true);
        const loadingStatus = ref("loading");
        const archaicResult = ref({});
        
        // A status this page doesn't know reads as still being processed, not a loader for good
        const showStatus = () => {
            const archaic = store.getters.kitTests?.archaic;
            if (!archaic) {
                loadingStatus.value = "loadingFailed";
            } else if (!archaic.purchased) {
                loadingStatus.value = "notPurchased";
            } else {
                (actions[archaic.status] ?? actions.pending)(loadingStatus, archaicResult);
            }
        };
        // The kit's tests are missing when they failed to load on the way in: ask for them again
        if (!store.getters.kitTests) {
            loadingStatus.value = "transferQcFailed";
        } else if (store.getters.kitTests.archaic) {
            showStatus();
        } else {
            store.dispatch("SET_KIT_TESTS", store.getters.profile?.profile?.barcode).catch(() => {}).finally(showStatus);
        }
        return { loadingStatus, archaicResult, showKitNotice };
    },
};
</script>
